var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section section-cards",attrs:{"id":"cards","data-background-color":"gray"}},[_c('blog-cards'),_c('profile-cards'),_c('full-background-cards'),_c('pricing-cards'),_c('plain-cards')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }